import React from "react";
import { useLocation } from "react-router-dom";

import ViewCommissionPage from "../../../../entities/DashboardPage/HRModule/ViewCommissionPage";

const ViewCommission = () => {
  const { state } = useLocation();
  const { item } = state || {};
  
  return (
    <>
      <ViewCommissionPage item={item}/>
    </>
  )

}

export default ViewCommission;
